import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

export const MobileBackButton = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        // Go back one screen.
        navigate(-1);
    };
    return (
        <IconButton
            data-testid="MobileBackButton"
            onClick={handleClick}
            sx={{ color: '#fafafa' }}
        >
            <ArrowBackIosNewIcon />
        </IconButton>
    );
};
